import { render, staticRenderFns } from "./SubTeam.vue?vue&type=template&id=1a44fb2b&scoped=true"
import script from "./SubTeam.vue?vue&type=script&lang=js"
export * from "./SubTeam.vue?vue&type=script&lang=js"
import style0 from "./SubTeam.vue?vue&type=style&index=0&id=1a44fb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44fb2b",
  null
  
)

export default component.exports